module.exports = __webpack_public_path__ + "4d174f9ed60421c3676c606341387846.pdf";